const GateType = [
  { id: 1, name: "In" },
  { id: 2, name: "Out" },
  { id: 3, name: "In/Out" },
];

const ServiceType = [
  { id: 1, name: "Valet" },
  { id: 2, name: "Hourly Valet" }, //hourly
  { id: 3, name: "Self Valet" },
  { id: 4, name: "Self Hourly Valet" }, //hourly
  { id: 5, name: "Re-Valet" },
  { id: 6, name: "Loss-Ticket" },
];
const HourlyServiceType = [
  { id: 2, name: "Hourly Valet" },
  { id: 4, name: "Self Hourly Valet" },
  { id: 8, name: "Hourly Validation Ticket" },
];
const FixedServiceType = [
  { id: 1, name: "Valet" },
  { id: 3, name: "Self Valet" },
  { id: 5, name: "Re-Valet" },
  { id: 6, name: "Loss-Ticket" },
  { id: 7, name: "ValidationTicket" },
];
const PaymentType = [
  { id: 0, name: "None" },
  { id: 1, name: "Void" },
  { id: 2, name: "Comp" },
  { id: 3, name: "Cash" },
  { id: 4, name: "CC" },
  { id: 5, name: "Elite" },
  { id: 10, name: "Eval" },
];
const PaymentTypeForm = [
  { id: 0, name: "None" },
  { id: 1, name: "Void" },
  { id: 3, name: "Cash" },
  { id: 4, name: "CC" },
  { id: 5, name: "Elite" },
];

const PaymentTypeNew = [
  { id: 3, name: "Cash" },
  { id: 4, name: "CC" },
  { id: 5, name: "Elite" },
];
const PaidStatusType = [
  { id: 1, name: "Unpaid" },
  { id: 2, name: "Partly Paid" },
  { id: 3, name: "Paid" },
  { id: 4, name: "PaidVoid" },
  { id: 5, name: "PaidComp" },
];
const PaidStatusEnum = [
  { id: 0, name: "All" },
  { id: 1, name: "Unpaid" },
  { id: 2, name: "Partly Paid" },
  { id: 3, name: "Paid" },
  { id: 4, name: "PaidVoid" },
  { id: 5, name: "PaidComp" },
  { id: 6, name: "PaidMember" },
];
const PaidVoidNoteType = [
  { id: 1, name: "Paid Void 1" },
  { id: 2, name: "Paid Void 2" },
  { id: 3, name: "Paid Void 3" },
];
const SmsType = [
  { id: 1, name: "Welcome" },
  { id: 2, name: "Car Ready" },
  { id: 3, name: "Re-Park" },
  { id: 4, name: "Custom message" },
];

const SmsStatusType = [
  { id: 1, name: "Success" },
  { id: 2, name: "Failure" },
];

const CarCategoryType = [
  { id: 1, name: "Indoor" },
  { id: 2, name: "Outdoor" },
];
const CarColorType = [
  { id: 1, name: "Black", HexValue: "#000" },
  { id: 2, name: "white", HexValue: "#FFFFFF" },
  { id: 3, name: "Silver", HexValue: "#C0C0C0" },
  { id: 4, name: "Gray", HexValue: "#808080" },
  { id: 5, name: "Red", HexValue: "#FF0000" },
  { id: 6, name: "Brown", HexValue: "#A52A2A" },
  { id: 7, name: "Orange", Hex: "#FFA500" },
  { id: 8, name: "Yellow", Hex: "#FFFF00" },
  { id: 9, name: "Violet", Hex: "#EE82EE" },
];
const CarMakerType = [
  { id: 1, name: "Alfa Romeo" },
  { id: 2, name: "Aston Martin" },
  { id: 3, name: "Audi" },
  { id: 4, name: "Bentley" },
];
const RolesEnum = [
  { roleId: "Head", name: "Head" },
  { roleId: "CoHead", name: "Co-Head" },
  { roleId: "Cashier", name: "Cashier" },
  { roleId: "KeyRack", name: "Key-Rack" },
  { roleId: "Runner", name: "Runner" },
  { roleId: "Moto", name: "Moto" },
  { roleId: "Supervisor", name: "Supervisor" },
  { roleId: "Concierge", name: "Concierge" },
  { roleId: "Extra", name: "Extra" },
  { roleId: "AuditorApp", name: "Auditor-App" },
];
const Units = [
  { id: 1, desription: "Piece" },
  { id: 2, desription: "M" },
  { id: 3, desription: "Kg" },
];
const ShowPrice = [
  { id: 0, desription: "No Price" },
  { id: 1, desription: "Official Price" },
  { id: 2, desription: "Trial Price" },
];

const WebContentTimes = [
  { id: 0, label: "Now" },
  { id: 5, label: "In 5 mins" },
  { id: 10, label: "In 10 mins" },
  { id: 15, label: "In 15 mins" },
  { id: 30, label: "In 30 mins" },
];
const InvoicesStatus = [
  { id: 0, desription: "New" },
  { id: 1, desription: "Under Processing" },
  { id: 2, desription: "Failure" },
  { id: 3, desription: "Success" },
];
const EmployeesRoles = [
  {
    id: "Head",
    name: "Head",
  },
  {
    id: "CoHead",
    name: "Co-Head",
  },
  {
    id: "Cashier",
    name: "Cashier",
  },
  {
    id: "KeyRack",
    name: "Key-Rack",
  },
  {
    id: "Runner",
    name: "Runner",
  },
  {
    id: "Moto",
    name: "Moto",
  },
  {
    id: "Supervisor",
    name: "Supervisor",
  },
  {
    id: "Concierge",
    name: "Concierge",
  },
  {
    id: "Extra",
    name: "Extra",
  },
  {
    id: "AuditorApp",
    name: "Auditor-App",
  },
];

const PlanEnum = [
  { id: 1, name: "Company" },
  { id: 2, name: "Site" },
  { id: 3, name: "Recharged" },
];

const MethodIds = [
  { id: 0, name: "None" },
  { id: 1, name: "Number" },
  { id: 2, name: "Plate" },
  { id: 3, name: "Mobile" },
  { id: 4, name: "Name" },
];

export {
  GateType,
  ServiceType,
  PaymentType,
  PaidStatusType,
  PaidStatusEnum,
  PaidVoidNoteType,
  SmsType,
  SmsStatusType,
  CarCategoryType,
  HourlyServiceType,
  FixedServiceType,
  CarColorType,
  CarMakerType,
  RolesEnum,
  Units,
  ShowPrice,
  InvoicesStatus,
  EmployeesRoles,
  PlanEnum,
  PaymentTypeForm,
  MethodIds,
  PaymentTypeNew,
  WebContentTimes,
};
